// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group.k5-form-group label[data-v-b156be36],.form-group.k5-form-group select[data-v-b156be36]{font-size:1.3rem;padding:1.15rem 1.65rem}", ""]);
// Exports
module.exports = exports;
